import { render, staticRenderFns } from "./TnCoordinate.vue?vue&type=template&id=d1c2fb40"
import script from "./TnCoordinate.vue?vue&type=script&lang=js"
export * from "./TnCoordinate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports